/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {BundlePositionsDetailContract} from '../../../api/contracts/bundle/bundle-positions-detail.contract';
import {BundlePositionsDetailModel} from './bundle-positions-detail.model';
import {BundlePositionSpecDetailMapper} from '../bundle-position-spec-detail/bundle-position-spec-detail.mapper';
import {CriterionBaseMapper} from '../../criterion-base/criterion-base.mapper';
import {ValueBaseMapper} from '../../value-base/value-base.mapper';
import {SettlementDetailMapper} from '../../settlement/settlement-detail/settlement-detail.mapper';


export class BundlePositionsDetailMapper {
    static fromBundlePositionsDetailContractArray(input: BundlePositionsDetailContract[]): BundlePositionsDetailModel[] {
        return input?.map((element) => BundlePositionsDetailMapper.fromBundlePositionsDetailContract(element));
    }

    static fromBundlePositionsDetailContract(input: BundlePositionsDetailContract): BundlePositionsDetailModel {
        let model: BundlePositionsDetailModel;

        if (input != null) {
            model = {
                totalValue: input.totalValue,
                settlementsList: SettlementDetailMapper.fromSettlementDetailContractArray(input.settlementsList),
                position: input.position,
                spec: BundlePositionSpecDetailMapper.fromBundlePositionSpecDetailContract(input.spec),
                criteria: CriterionBaseMapper.fromCriterionBaseContractArray(input.criteria),
                values: ValueBaseMapper.fromValueBaseContractArray(input.values)
            };
        }
        return model;
    }
}
